<template>
  <basic-dialog :show="show" @close="$emit('close')" max-width="800px">
    <template v-slot:title>{{ title }}</template>
    <v-row>
      <v-col>
        <agent-group-select
          v-model="groupId"
          :outlined="outlinedInputs"
          :groupsOnly="true"
        ></agent-group-select>
      </v-col>
      <v-col>
        <department-list-select
          :outlined="outlinedInputs"
          v-model="department"
          show-all
        ></department-list-select>
      </v-col>
      <v-col>
        <destination-list-select
          v-model="destinationId"
          :outlined="outlinedInputs"
        ></destination-list-select>
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <v-text-field
          label="Accommodation %"
          v-model="accommodation"
          :outlined="outlinedInputs"
        ></v-text-field>
      </v-col>
      <v-col>
        <v-text-field
          label="Transport %"
          v-model="transport"
          :outlined="outlinedInputs"
        ></v-text-field>
      </v-col>
      <v-col>
        <v-text-field
          label="Activity %"
          v-model="activity"
          :outlined="outlinedInputs"
        ></v-text-field>
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <v-text-field
          label="Travel %"
          v-model="travel"
          :outlined="outlinedInputs"
        ></v-text-field>
      </v-col>
      <v-col>
        <v-text-field
          label="Other %"
          v-model="other"
          :outlined="outlinedInputs"
        ></v-text-field>
      </v-col>
      <v-col>
        <v-text-field
          label="Package %"
          v-model="packageValue"
          :outlined="outlinedInputs"
        ></v-text-field>
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <tags-select
          v-model="tagsList"
          owner="SUPPLIER"
          :outlined="outlinedInputs"
        ></tags-select>
      </v-col>
      <v-col v-if="false">
        <v-switch v-model="round" label="Use Rounding"></v-switch>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" sm="4">
        <v-switch v-model="useDateRange" label="Use Date Range"></v-switch>
      </v-col>
      <v-col cols="12" sm="8">
        <dates-range-picker
          :disabled="!useDateRange"
          :outlined="outlinedInputs"
          :gt-date-from-string="validFrom"
          :gt-date-to-string="validTo"
          @onRangeSelected="onDatesChange"
        ></dates-range-picker>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" sm="4"> Iti creation date range: </v-col>
      <v-col cols="12" sm="8">
        <dates-range-picker
          :outlined="outlinedInputs"
          :gt-date-from-string="itineraryCreatedFrom"
          :gt-date-to-string="itineraryCreatedTo"
          @onRangeSelected="onItiDatesChange"
        ></dates-range-picker>
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <v-switch v-model="notInUse" label="Not In Use"></v-switch>
      </v-col>
      <v-col>
        <v-switch v-model="historicalOnly" label="Historical Only"></v-switch>
      </v-col>
    </v-row>
    <v-row v-if="debug">
      <v-col cols="12">
        value:
        <code>{{ value }} || markup: {{ markup }}</code>
      </v-col>
    </v-row>
    <changelogs-dialog
      v-if="value && value.id"
      :owner-id="value.id"
      :show="showChangelogs"
      @close="showChangelogs = false"
    />
    <template v-slot:actions>
      <v-btn @click="onShowChangelogs">Logs</v-btn>
      <v-btn color="primary" @click="onSave">Save</v-btn>
    </template>
  </basic-dialog>
</template>

<script>
import BasicDialog from "../../shared/BasicDialog";
import AgentGroupSelect from "../../shared/AgentGroupSelect";
import DepartmentListSelect from "../../shared/DepartmentListSelect";
import DestinationListSelect from "../../shared/DestinationListSelect";
import { updateObj } from "../../../../helpers/index";
import DatesRangePicker from "../../shared/DatesRangePicker";
import TagsSelect from "../../shared/TagsSelect";
import ChangelogsDialog from "../../shared/ChangelogsDialog";
export default {
  name: "edit-markup-dialog",

  props: {
    show: {
      type: Boolean,
      default: () => false,
    },
    value: {
      type: Object,
      default: () => {},
    },
    title: {
      type: String,
      default: () => "Edit Markup",
    },
  },

  components: {
    TagsSelect,
    BasicDialog,
    AgentGroupSelect,
    DepartmentListSelect,
    DestinationListSelect,
    DatesRangePicker,
    ChangelogsDialog,
  },

  data() {
    return {
      debug: false,
      groupId: this.value ? this.value.groupId : "",
      department: this.value ? this.value.department : "All",
      destinationId: this.value ? this.value.destinationId : "",
      accommodation: this.value ? this.value.accommodation : "",
      transport: this.value ? this.value.transport : "",
      activity: this.value ? this.value.activity : "",
      travel: this.value ? this.value.travel : "",
      other: this.value ? this.value.other : "",
      packageValue: this.value ? this.value.package : "",
      useDateRange: this.value ? this.value.useDateRange : false,
      round:
        this.value && this.value.round
          ? this.value.round.toString() == "true"
          : false,
      validFrom: this.value ? this.value.validFrom : "",
      validTo: this.value ? this.value.validTo : "",
      tagsList: this.value ? this.value.tagsList : "",
      notInUse: this.value ? this.value.notInUse : false,
      historicalOnly: this.value ? this.value.historicalOnly : false,
      itineraryCreatedFrom: this.value ? this.value.itineraryCreatedFrom : "",
      itineraryCreatedTo: this.value ? this.value.itineraryCreatedTo : "",
      showChangelogs: false,
    };
  },

  watch: {
    value(newVal) {
      this.packageValue = newVal.package;
      updateObj(newVal, this, [
        "groupId",
        "department",
        "destinationId",
        "accommodation",
        "transport",
        "activity",
        "travel",
        "other",
        "useDateRange",
        "round",
        "validFrom",
        "validTo",
        "tagsList",
        "notInUse",
        "historicalOnly",
        "itineraryCreatedFrom",
        "itineraryCreatedTo",
      ]);
    },
  },

  computed: {
    outlinedInputs() {
      return this.$store.getters.localSettings("outlinedInputs");
    },
    markup() {
      return {
        id: this.value && this.value.id ? this.value.id : undefined,
        groupId: this.groupId,
        destinationId:
          this.destinationId != "" ? this.destinationId : undefined,
        department: this.department,
        accommodation:
          this.accommodation != "" ? Number(this.accommodation) : null,
        activity: this.activity != "" ? Number(this.activity) : null,
        transport: this.transport != "" ? Number(this.transport) : null,
        travel: this.travel != "" ? Number(this.travel) : null,
        package: this.packageValue != "" ? Number(this.packageValue) : null,
        other: this.other != "" ? Number(this.other) : null,
        useDateRange: this.useDateRange,
        round: this.round.toString() == "true",
        validFrom: this.validFrom,
        validTo: this.validTo,
        tagsList: this.tagsList,
        notInUse: this.notInUse,
        historicalOnly: this.historicalOnly,
        itineraryCreatedFrom: this.itineraryCreatedFrom,
        itineraryCreatedTo: this.itineraryCreatedTo,
      };
    },
  },

  methods: {
    onShowChangelogs() {
      this.showChangelogs = true;
    },
    onSave() {
      this.$emit("input", { ...this.markup });
      this.$emit("save", { ...this.markup });
    },
    onDatesChange(payload) {
      if (payload.dateFrom) {
        this.validFrom = payload.dateFrom;
      }
      if (payload.dateTo) {
        this.validTo = payload.dateTo;
      }
    },
    onItiDatesChange(payload) {
      if (payload.dateFrom) {
        this.itineraryCreatedFrom = payload.dateFrom;
      }
      if (payload.dateTo) {
        this.itineraryCreatedTo = payload.dateTo;
      }
    },
  },
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/gt/plugins/markups/EditMarkupDialog.vue